export default __webpack_public_path__ + "static/media/server.7d3d5ab8.png";